import { render, staticRenderFns } from "./COD.vue?vue&type=template&id=fd9b0694&scoped=true&"
import script from "./COD.vue?vue&type=script&lang=js&"
export * from "./COD.vue?vue&type=script&lang=js&"
import style0 from "./COD.vue?vue&type=style&index=0&id=fd9b0694&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd9b0694",
  null
  
)

export default component.exports